import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["lang"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useContext, useState, useCallback } from 'react';
var I18nContext = React.createContext();
var loadLocaleFrom = function loadLocaleFrom(lang) {
  return import("./locales/".concat(lang, "/adyen.json")).then(function (m) {
    return m["default"];
  });
};
export var useTranslation = function useTranslation() {
  return useContext(I18nContext);
};
export function I18nProvider(_ref) {
  var lang = _ref.lang,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    d = _useState2[0],
    setD = _useState2[1];
  useEffect(function () {
    var isMounted = true;
    makeTranslator(lang).then(function (translations) {
      if (isMounted && JSON.stringify(d) !== JSON.stringify(translations)) {
        setD(translations);
      }
    });
    return function () {
      isMounted = false;
    };
  }, [lang]);
  var t = useCallback(function () {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var query = arguments.length > 1 ? arguments[1] : undefined;
    var value = d[key];
    return interpolation(value, query) || key;
  }, [d]);
  return React.createElement(I18nContext.Provider, _extends({
    value: {
      t: t,
      lang: lang
    }
  }, props));
}
export function withI18n(Component) {
  function ComponentWithI18n(props) {
    return React.createElement(I18nProvider, {
      lang: props.lang
    }, React.createElement(Component, _extends({}, props, {
      ref: ref
    })));
  }
  ComponentWithI18n.displayName = Component.displayName || 'withI18n(GenericPaymentComponent)';
  return ComponentWithI18n;
}
var allowedLangs = ['en', 'es', 'it', 'fr', 'ca', 'pt', 'de'];
function interpolation(text, query) {
  if (!text || !query) return text || '';
  return Object.keys(query).reduce(function (all, varKey) {
    var regex = new RegExp("{{\\s*".concat(varKey, "\\s*}}"), 'gm');
    all = all.replace(regex, "".concat(query[varKey]));
    return all;
  }, text);
}
function makeTranslator(_x) {
  return _makeTranslator.apply(this, arguments);
}
function _makeTranslator() {
  _makeTranslator = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(lang) {
    var langCode;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          langCode = allowedLangs.find(function (l) {
            return l === lang;
          }) || 'en';
          return _context.abrupt("return", loadLocaleFrom(langCode));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _makeTranslator.apply(this, arguments);
}
I18nProvider.defaultProps = {
  lang: 'en'
};